/**
 * Browser entry point.
 *
 * Importing `lib/i18n` and the persisted stores has the side effect of
 * applying the user's last-known locale and theme to <html> before the
 * React tree mounts — preventing a flash of the wrong direction or
 * colors. The order of these imports is therefore deliberate:
 *   1. i18n init (registers ar/en bundles, default Arabic)
 *   2. theme + lang stores rehydrate from localStorage and patch the
 *      DOM via their `onRehydrateStorage` callbacks
 *   3. React mounts and the application renders with the right paint
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles/index.css";
import "./lib/i18n";
import "./stores/themeStore";
import "./stores/langStore";
import { App } from "./App";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Could not find #root element");

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
